import React from "react";
import { Lightbulb } from "lucide-react";

export const ReportCompetitors = ({ strategy }) => {
  const comp = strategy.competitor_analysis || {};
  return (
    <div className="space-y-6">
      {(comp.competitors || []).map((competitor, i) => {
        const name = typeof competitor === "object" ? competitor.name : competitor;
        return (
          <div key={`comp-${name}-${i}`} className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
            <h3 className="font-semibold text-white text-lg mb-4">{name}</h3>
            {typeof competitor === "object" && (
              <div className="space-y-4">
                <div>
                  <p className="text-sm font-medium text-slate-400 mb-1">Positioning</p>
                  <p className="text-slate-300">{competitor.positioning}</p>
                </div>
                {competitor.differentiation_opportunity && (
                  <div className="bg-emerald-900/20 border border-emerald-500/30 p-4 rounded-xl">
                    <p className="text-sm font-medium text-emerald-400">How to Differentiate</p>
                    <p className="text-slate-300 text-sm">{competitor.differentiation_opportunity}</p>
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
      {comp.market_gaps && comp.market_gaps.length > 0 && (
        <div className="bg-gradient-to-br from-emerald-900/30 to-slate-900 border border-emerald-500/30 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-4">Market Gaps & Opportunities</h3>
          <ul className="space-y-2">
            {comp.market_gaps.map((gap) => (
              <li key={`gap-${gap.slice(0, 30)}`} className="flex items-start gap-2 text-slate-300">
                <Lightbulb className="w-4 h-4 mt-1 text-emerald-400 flex-shrink-0" /> {gap}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
